var ajaxCalls = require('./ajaxCalls');

var report = function(exam,global) {
    var question = global.response.answers[global.questionIndex].question;


    var modalDiv = $('#'+ global.modal);
    $(modalDiv).on('hidden.bs.modal', function (e) {


        $(modalDiv).find('.modal-content').html('');



    });
    var modalcontentstr = '<div class="modal-header">Report Issue</div><div class="modal-body feedback">' +
        'As part of our ongoing work to produce accurate, up-to-date, and robust exam prep questions, we thank you for helping us identify text or images that might need a second look.<br/>' +
        '<br/>' +
        'Please use the space below to describe the problem you have with this question. We appreciate your thorough feedback, as it helps us to look into the matter in a timely manner.<br/><textarea class="form-control message"></textarea>' +
        '</div><div class="modal-footer"><button type="button" class="btn btn-default">Send</button></div>';
    var modalContent = $.parseHTML(modalcontentstr);
    $(modalDiv).find('.modal-content').append(modalContent);
    $(modalDiv).find('button').click(function() {
        var data = $(modalDiv).find('textarea').val();
        if (data.length) {
            ajaxCalls.report(question.id,global.userId,$(modalDiv).find('textarea').val(),function(response) {
                alert('Thank you.');
                $(modalDiv).modal('hide');
            });
        }
    })
    $(modalDiv).modal();
}

module.exports = report;


//////////////////
// WEBPACK FOOTER
// ./src/report.js
// module id = 233
// module chunks = 0